const ticketTimeFilter = function (input) {
    return (input == null || input == '') ? 'Open Ticket' : input;
};

/* istanbul ignore next */
if (typeof module !== 'undefined' && module.exports) {
    module.exports = ticketTimeFilter;
}
